export default "__VITE_ASSET__786fd7a9__"